import script from "./NotificationRow.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationRow.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import BasicBadge from "@/components/BasicBadge.vue";
import NeueToggle from "@/components/neue/NeueToggle.vue";
import NotificationEmailsPopover from "@/components/settings/NotificationEmailsPopover.vue";
script.components = Object.assign({}, { BasicBadge, NeueToggle, NotificationEmailsPopover }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { BasicBadge, NeueToggle, NotificationEmailsPopover }, script.__o.components);}